import React, { useState } from "react";
import { useEffect } from "react";
import Image from "next/image";
import { FacebookShareButton, EmailShareButton } from "react-share";
import Buttons from "../Button/Button";
import Facebook from "../../assets/imgs/iconsforTrack/Facebook-Icon.svg";
// import WhatsApp from '../../assets/imgs/socialIcon/whats-app.svg';
// import Messenger from '../../assets/imgs/email_black_24dp.svg';
import Email from "../../assets/imgs/iconsforTrack/email_black_24dp.svg";
// import Twitter from '../../assets/imgs/socialIcon/twitter.svg';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import styles from "./ShareThisTrack.module.css";

import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import { Container } from "@mui/material";

function ShareThisTrack(props) {
  const { trackDetails, showTitle } = props;

  const [isCopied, setIsCopied] = useState(false);

  const [courseShareLink, setCourseShareLink] = useState("");

  useEffect(() => {
    setCourseShareLink(
      typeof trackDetails.slug !== "undefined"
        ? window.location.origin + `/track/${trackDetails.slug}`
        : window.location.href
    );
  });

  // do the text copy operation
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call courseShareLinkToClipboard
    copyTextToClipboard(courseShareLink)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const instructorName = instructorFullName? instructorFullName : course?.instructors[0]?.instructorName;

  return (
    <div className={`${styles.ShareThisCourse} ${"WhiteSection"}`} id="share">
      {showTitle == true && <h1 className="TitleSmall">Share this track</h1>}

      <Container maxWidth="sm" sx={{ py: 2 }}>
        <div className={styles.SocialLinks}>
          <Grid container spacing={2}>
       

            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.SocialButtons}>
                <FacebookShareButton
                  url={courseShareLink}
                  quotes={trackDetails.name}
                  hashtag={"#hashtag"}
                  description={trackDetails.description}
                  style={{ minHeight: "64px", paddingLeft: "19px" }}
                  className={styles.ShareButton}
                >
                  <Image src={Facebook} /> &nbsp; Facebook
                </FacebookShareButton>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.SocialButtons}>
                <EmailShareButton
                  subject={trackDetails.name}
                  body={`Thought you might like this track at Takbir : ${trackDetails.name}.\nTrack details available at here: ${courseShareLink}\nTakbir (mytakbir.com) is an online, secured and easy-to-use platform for learners and amazing teachers. \nFollow Takbir - https://www.facebook.com/mytakbir`}
                  separator=" "
                  url={""}
                  style={{ minHeight: "64px", paddingLeft: "19px" }}
                  className={styles.ShareButton}
                >
                  <Image src={Email} /> &nbsp; Email
                </EmailShareButton>
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <p className="HelperTextSocial" style={{fontWeight:"500", color:"#0B132B", fontSize:"14px", margin:"0"}}>
                Copy and paste this link anywhere
              </p>
              <div className="TextField ModalCopyField">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={courseShareLink}
                  readOnly
                />
                <div style={{ width: "96%", margin: "0 auto" }}>
                  <Buttons
                    label={isCopied ? "Copied!" : "Copy Link"}
                    buttonColor="#004FE0"
                    color="#fff"
                    height="48px"
                    fontSize="14px"
                    link=""
                    width="100%"
                    onClick={handleCopyClick}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}></div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}

export default ShareThisTrack;
